import {ChangeDetectionStrategy, Component, DestroyRef} from '@angular/core'
import {AuthenticatedUser, AuthStatusService} from '../../../../auth/auth-status.service'
import {AGENT_ROUTES} from '../../../../../shared/routing/agent.routes'
import {ADMIN_ROUTES} from '../../../../../shared/routing/admin.routes'
import {CLIENT_ROUTES} from '../../../../../shared/routing/client.routes'
import {PRO_ROUTES} from '../../../../../shared/routing/pro.routes'
import {faChartLine} from '@fortawesome/pro-solid-svg-icons/faChartLine'
import {faGridHorizontal} from '@fortawesome/pro-solid-svg-icons/faGridHorizontal'
import {faScrewdriverWrench} from '@fortawesome/pro-solid-svg-icons/faScrewdriverWrench'
import {LinkService} from '../../../../i18n/link.service'
import {USER_ROUTES} from '../../../../../shared/routing/user.routes'
import {MessagingService} from '../../../../messaging/messaging.service'
import {filter, map, skipWhile, switchMap, tap} from 'rxjs/operators'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {Observable} from 'rxjs'
import {AuthService} from '../../../../auth/auth.service'
import {faComment} from '@fortawesome/pro-solid-svg-icons/faComment'
import {Logger} from '../../../../logging/logger.types'

@Component({
  selector: 'bgo-auth-shortcuts',
  templateUrl: './auth-shortcuts.component.html',
  styleUrls: ['./auth-shortcuts.component.css', './navbar-shortcuts-common.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthShortcutsComponent {
  protected readonly authenticatedUser$ = this.authStatus.authenticatedUser$

  protected readonly adminJobsLink = this.linkService.localizedPathTo(ADMIN_ROUTES.ADMIN_JOBS)
  protected readonly adminJobsIcon = faScrewdriverWrench

  protected readonly agentDashboardLink = this.linkService.localizedPathTo(AGENT_ROUTES.AGENT_HOME)
  protected readonly agentDashboardIcon = faChartLine

  protected readonly proDashboardLink = this.linkService.localizedPathTo(PRO_ROUTES.PRO_HOME)
  protected readonly proDashboardIcon = faChartLine

  protected readonly clientJobsLink = this.linkService.localizedPathTo(CLIENT_ROUTES.CLIENT_JOBS)
  protected readonly clientJobsIcon = faGridHorizontal

  protected readonly messagesLink = this.linkService.localizedPathTo(USER_ROUTES.USER_MESSAGES)
  protected readonly messagesIcon = faComment
  protected messageUnreadCount$?: Observable<number>

  constructor(
    protected readonly authStatus: AuthStatusService,
    private readonly auth: AuthService, // inject auth to trigger authentication of the user
    private readonly linkService: LinkService,
    private readonly messagingService: MessagingService,
    private readonly destroyRef: DestroyRef,
    private readonly logger: Logger,
  ) {
    this.loadUnreadMessages()
  }

  loadUnreadMessages() {
    this.messageUnreadCount$ = this.messagingService.unreadCount$()
    // load rooms in order to get unread state. This is not ideal as we're loading more than we need to
    // if this becomes more than messages (ie diverse notifications), we could provide a more specific query
    this.authStatus.authenticatedUser$
      .pipe(
        skipWhile(value => value.isLoading), // wait until authentication status is known
        map(res => res.authenticatedUser),
        filter((user): user is AuthenticatedUser => !!user),
        tap(user => this.logger.debug(`AuthShortcutsComponent: Fetching unread messages for ${user?.userId}`)),
        switchMap(user => this.messagingService.loadAllRooms$(user.userId)),
        takeUntilDestroyed(this.destroyRef),
      )
      // subscribe to trigger the query
      .subscribe()
  }
}
